import { render, staticRenderFns } from "./RegisterAdminWorkspace.vue?vue&type=template&id=0209ee79&scoped=true"
import script from "./RegisterAdminWorkspace.vue?vue&type=script&lang=js"
export * from "./RegisterAdminWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RegisterAdminWorkspace.vue?vue&type=style&index=0&id=0209ee79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0209ee79",
  null
  
)

export default component.exports